import React, { Component } from 'react';
 
class Footer extends Component {
  render() {
    return (
        <footer>
          <div id="footer">
            <div id="footerLeft">&copy; 2025 Christchurch Marine Conservation</div>
          </div>
        </footer>
    );
  }
}
 
export default Footer;


